import { CORE_API } from "../constants";
import { postData } from "./common.service";


export type TLanguageUpdateResponse = {
  success: boolean;
  message: string;
};

export const updateUserLanguage = (userId: string, newLang: string): Promise<TLanguageUpdateResponse> => {
  const url = `/farm-users/${userId}`;   

  const body = {
    lang: newLang   
  };


  return postData(
    url,
    {
      sendTokenInHeader: true, 
      usePatchMethod: true,
      basePath: CORE_API,
      body: body
    }
  );
};
